import React from "react";
import { FaArrowCircleLeft } from "react-icons/fa";

const BackButton = ({ handleClick }) => {
  return (
    <div>
      <button
        onClick={handleClick}
        className="bg-primary-color btn border-0 d-flex align-items-center justify-content-center rounded-0"
        style={{
          color: "#fff",
          borderRadius: "5px",
          padding: "6px 18px",
        }}
      >
        <FaArrowCircleLeft size={22} className="me-2" />
        <span>Go Back</span>
      </button>
    </div>
  );
};

export default BackButton;
